<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Edit Bank Card</p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    @if (dataError) {
      <opa-reload-button [label]="'Reload Edit Bank Card'" (click)="reloadData()" />
    } @else if (data) {
      <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
        <p-select-wrapper
          *ngrxLet="form.controls.userId as control"
          [filter]="true"
          [label]="'Person'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <select [attr.required]="true" [formControl]="control">
            <option *ngFor="let user of data.users; trackBy: trackUser" [value]="user.id">
              {{ user.firstName }} {{ user.lastName }}
            </option>
          </select>
        </p-select-wrapper>

        <p-text-field-wrapper
          *ngrxLet="form.controls.cardNumber as control"
          [description]="'Only last 4 digits'"
          [label]="'Card Number'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <input type="text" [attr.required]="true" [formControl]="control" />
        </p-text-field-wrapper>

        <p-text-field-wrapper
          *ngrxLet="form.controls.dailyLimit as control"
          [label]="'Daily Limit'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
          [unit]="defaultCurrencyCode"
          [unitPosition]="'suffix'"
        >
          <input type="number" [attr.required]="true" [formControl]="control" />
        </p-text-field-wrapper>

        <p-switch
          *ngrxLet="form.controls.pos as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          POS
        </p-switch>

        <p-switch
          *ngrxLet="form.controls.atm as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          ATM
        </p-switch>

        <p-switch
          *ngrxLet="form.controls.bankingPermissions as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          Banking Permissions
        </p-switch>

        <p-switch
          *ngrxLet="form.controls.createPaymentWarrants as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          Create Payment Warrants
        </p-switch>

        <p-switch
          *ngrxLet="form.controls.authorizePaymentWarrants as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          Authorize Payment Warrants
        </p-switch>

        <p-switch
          *ngrxLet="form.controls.mobileApp as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          Mobile APP
        </p-switch>

        <p-text-field-wrapper
          *ngrxLet="form.controls.expirationDate as control"
          [label]="'Expiration date'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <input type="date" [attr.required]="true" [formControl]="control" />
        </p-text-field-wrapper>

        <p-switch
          *ngrxLet="form.controls.active as control"
          [disabled]="control.disabled"
          [checked]="control.value ?? false"
          (update)="control.patchValue($event.detail.checked)"
        >
          Active
        </p-switch>
      </form>

      <p-button-group slot="footer">
        <p-button [form]="formId" [loading]="data.submitting" [type]="'submit'">Save</p-button>
        <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
          Close
        </p-button>
      </p-button-group>
    }
  </ng-container>
</p-modal>

<ng-template #spinner>
  <opa-spinner />
</ng-template>
